import { FC, ReactNode } from 'react';
import { Col, Row } from 'antd';
import { TbChevronRight } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { ResourceVisibilityDropdown } from '@/shared';

interface ResourceCreationModalTitleProps {
    disabled?: boolean;
    icon: ReactNode;
    setVisibility: (visibility: string) => void;
    title: ReactNode;
    visibility: string;
    visibilityOptions?: string[];
}

const ResourceCreationModalTitle: FC<ResourceCreationModalTitleProps> = ({
    disabled,
    icon,
    setVisibility,
    title,
    visibility,
    visibilityOptions,
}): JSX.Element => {
    const { token } = useAntDesignTheme();

    return (
        <Row align='middle' wrap={false} gutter={[8, 0]}>
            <Col flex='none'>
                <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                    <span style={{ display: 'inline-flex', alignItems: 'center', marginRight: '0.5rem' }}>{icon}</span>
                    {title}
                </span>
            </Col>
            <Col flex='none'>
                <TbChevronRight style={{ color: token.colorTextTertiary, verticalAlign: '-0.125rem' }} />
            </Col>
            <Col flex='none'>
                <ResourceVisibilityDropdown
                    disabled={disabled}
                    options={visibilityOptions}
                    visibility={visibility}
                    setVisibility={setVisibility}
                />
            </Col>
        </Row>
    );
};

export default ResourceCreationModalTitle;
